document.addEventListener("DOMContentLoaded", function () {
  console.log('here'); //add a global event listener for the training dates selector

  document.body.addEventListener("change", function (event) {
    //if this is not the training dates selector, return
    if (!event.target.matches(".training-dates-selector")) return; //get the value of the training dates selector

    var value = event.target.value; //set this value to the data-show attribute of the parent element

    event.target.parentElement.dataset.show = value;
  });
});